import React from "react";
import { Helmet } from "react-helmet";

const ProfileOfBoardOfDirector = () => {
  return (
    <div>
      <Helmet>
        <title>Profile Of Board Of Director | Nandan Denim Ltd .</title>
      </Helmet>

    </div>
  )
};

export default ProfileOfBoardOfDirector;
